<template>
  <div :class="`card ${variant}`">
    <div
      v-if="!hideHeader"
      class="card-header"
    >
      <label :for="id" v-html="label"></label>
    </div>
    <div :class="{ 'card-body': true, 'p-0': noBodyPadding, 'p-2': !noBodyPadding }" v-if="!noBody">
      <slot name="card-body">
        <large-input
          :id="id"
          v-model="currentValue"
          :icon="icon"
          :placeholder="placeholder"
          :help="help"
          :readonly="readonly"
          :type="type"
          :append-icon="appendIcon"
        />
      </slot>
    </div>
    <div
      v-if="!hideFooter"
      class="card-footer p-0"
    >
      <slot name="card-footer"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
label {
  margin: 0;
}

.section {
  border-color: #111;
  border-width: 2px;
  &> .card-header {
    text-transform: uppercase;
    font-size: 1.0rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0;
  }

  &.wider {
    flex: 1 1 34%;
  }
}

.component {
  margin: 0;
  border: 0;
  border-color: transparent;
  &> .card-header {
    border-radius: 0 !important;
    font-size: 1.0rem;
    text-align: left;
    background-color: transparent;
    padding: 0.75rem 0.6rem 0;
    border-bottom: 0;
    label {
      font-weight: bold;
    }
  }
}
</style>

<script>
import { v1 as uuidv1 } from 'uuid'
import LargeInput from './LargeInput'

export default {
  components: {
    LargeInput
  },
  props: {
    id: {
      type: String,
      default () {
        return uuidv1()
      }
    },
    noBody: {
      type: Boolean,
      default: false
    },
    noBodyPadding: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default'
    },
    type: {
      type: String,
      default: 'number'
    },
    hint: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Label'
    },
    icon: {
      type: String,
      default: 'fa-hashtag'
    },
    help: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    placeholder: {
      type: [String, Number],
      default: ''
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    },
    currentValue () {
      this.$emit('input', this.currentValue)
    }
  },
  computed: {
    hasCardFooter () {
      return !!this.$slots.cardFooter
    }
  }
}
</script>